module.exports = __webpack_public_path__ + "static/feature2-843b5f188278ec13e205248fc86d06de.png";